export default __webpack_public_path__ + "static/media/EmptyState.8d4cd234.svg";